// extracted by mini-css-extract-plugin
export default {"sobrenos":"Sobre_sobrenos__uHxxy"};